import { SEO, breadcrumbSchema } from "../components/SEO";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { Reveal } from "../components/Reveal";
import { CTASection } from "../components/CTASection";
import { ProcessSteps } from "../components/ProcessSteps";
import { business } from "../content/site";
import { useLp } from "../i18n/lang";
import { useCopy } from "../i18n/copy";

export default function About() {
  const c = useCopy("about");
  const cr = useCopy("crumbs");
  const lp = useLp();
  const crumbs = [
    { name: cr.home, path: lp("/") },
    { name: cr.about, path: lp("/sobre-midefinca/") },
  ];
  const whoP1 = c.whoP1
    .replace("{qualification}", business.qualification)
    .replace("{collegiate}", business.collegiate);
  return (
    <>
      <SEO
        title={c.seoT}
        description={c.seoD}
        path="/sobre-midefinca/"
        jsonLd={[breadcrumbSchema(crumbs)]}
      />
      <Breadcrumbs items={crumbs} />
      <section className="container-site section-gap !pt-10" data-testid="about-page">
        <Reveal>
          <p className="tech-label mb-4">{c.kicker}</p>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight max-w-3xl">
            {c.h1}
          </h1>
          <p className="mt-5 max-w-2xl text-base sm:text-lg text-slate-600 leading-relaxed">
            {c.intro}
          </p>
        </Reveal>

        <Reveal className="mt-16 max-w-5xl" data-testid="about-professional">
          <div className="grid md:grid-cols-2 gap-px bg-slate-200 border hairline">
            <div className="bg-[#E8E0D1] min-h-64">
              <img
                src="/trabajo-campo.webp"
                alt={c.imgAlt}
                width="1536"
                height="1024"
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="bg-[#E8E0D1] p-8 sm:p-10">
              <h2 className="text-xl sm:text-2xl font-semibold text-[#183F3A]">{c.whoH}</h2>
              <div className="mt-5 space-y-3 text-[15px] text-slate-700 leading-relaxed">
                <p>
                  <strong className="text-ink">{c.dtLabel}</strong> {whoP1}
                </p>
                <p>{c.whoP2}</p>
              </div>
            </div>
          </div>
        </Reveal>

        <div className="mt-16">
          <Reveal>
            <h2 className="text-2xl sm:text-3xl font-semibold text-[#183F3A] max-w-2xl">{c.principlesH}</h2>
          </Reveal>
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200 border hairline max-w-5xl">
            {c.principles.map((p, i) => (
              <Reveal key={p.n} delay={i * 0.05} className="bg-[#E8E0D1]">
                <div className="p-8">
                  <span className="font-mono text-sm text-terracotta tracking-widest">[{p.n}]</span>
                  <h3 className="mt-3 text-lg font-semibold text-ink">{p.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{p.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <div className="mt-16">
          <Reveal>
            <h2 className="text-2xl sm:text-3xl font-semibold text-[#183F3A] max-w-2xl">{c.processH}</h2>
          </Reveal>
          <div className="mt-10">
            <ProcessSteps compact />
          </div>
        </div>
      </section>
      <CTASection title={c.ctaT} text={c.ctaX} />
    </>
  );
}
